import { observable, action, IObservableArray, toJS } from "mobx";
import { PersistentStore } from "./PersistentStore"
import * as DocumentReader from "../DocumentReader";

export interface IDocumentFilter {
	documentFilters: IObservableArray<DocumentReader.DocumentFilter>;
	getDocumentFilters: () => DocumentReader.DocumentFilter[];
	setFilter: (filter: DocumentReader.DocumentFilter) => void;
	deleteFilter: (filter: DocumentReader.DocumentFilter) => void;
	deleteFilterByKey: (key: string) => void;
	hasFilter: (key: string) => boolean;
	findFilter: (key: string) => DocumentReader.DocumentFilter;
	clearFilter: () => void;
}

export class DocumentFilterClean implements IDocumentFilter {

	@observable documentFilters: IObservableArray<DocumentReader.DocumentFilter> = observable.array([]);

	/**
	 * Get current filters
	 */
	@action getDocumentFilters = () => {
		return this.documentFilters;
	}

	/**
	 * Set filter
	 * @param filter New filter object.
	 */
	@action setFilter = (filter: DocumentReader.DocumentFilter) => {
		this.deleteFilterByKey(filter.name);
		this.documentFilters.push(filter);
	}

	/**
	 * Delete a filter
	 * @param filter Filter to be deleted.
	 * @param value The selected filter value.
	 */
	@action deleteFilter = (filter: DocumentReader.DocumentFilter) => {
		let index = this.documentFilters.indexOf(filter)
		if (index > -1) {
			this.documentFilters.splice(index, 1);
		}
	}

	/**
	 * Delete a filter by filter key
	 * @param key Key of the filter to be deleted.
	 */
	@action deleteFilterByKey = (key: string) => {
		let filter = this.documentFilters.find(item => item.name.indexOf(key) !== -1);
		if (filter != null) {
			let index = this.documentFilters.indexOf(filter)
			if (index > -1) {
				this.documentFilters.splice(index, 1);
			}
		}
	}

	/**
	 * Check existence of the filter
	 * @param key Key of the filter to be checked for existence.
	 */
	@action hasFilter = (key: string) => {
		return this.documentFilters.some(filter => filter.name == key);
	}

	/**
	 * Find filter by key
	 * @param key Key of the filter to be found.
	 */
	@action findFilter = (key: string) => {
		return this.documentFilters.find(filter => filter.name == key);
	}

	/**
	 * Clear filters.
	 */
	@action clearFilter = () => {
		return this.documentFilters.clear();
	}
}


class DocumentFilterPersistentImpl extends PersistentStore implements IDocumentFilter {

	/**
	 * Document filter stored separately for accessing from different page
	 */
	constructor() {
		super("documentFilter");
		this.loadAsync();
	}

	@observable documentFilters: IObservableArray<DocumentReader.DocumentFilter> = observable.array([]);

	/**
	 * Get current filters
	 */
	@action getDocumentFilters = () => {
		let filters = toJS(this.documentFilters.filter(filter => filter.name != "")) as Array<DocumentReader.DocumentFilter>;
		return filters;
	}

	/**
	 * Set filter
	 * @param filter New filter object.
	 */
	@action setFilter = (filter: DocumentReader.DocumentFilter) => {
		this.deleteFilterByKey(filter.name);
		this.documentFilters.push(filter);
	}

	/**
	 * Delete a filter
	 * @param filter Filter to be deleted.
	 * @param value The selected filter value.
	 */
	@action deleteFilter = (filter: DocumentReader.DocumentFilter) => {
		let index = this.documentFilters.indexOf(filter)
		if (index > -1) {
			this.documentFilters.splice(index, 1);
		}
	}

	/**
	 * Delete a filter by filter key
	 * @param key Key of the filter to be deleted.
	 */
	@action deleteFilterByKey = (key: string) => {
		let filter = this.documentFilters.find(item => item.name.indexOf(key) !== -1);
		if (filter != null) {
			let index = this.documentFilters.indexOf(filter)
			if (index > -1) {
				this.documentFilters.splice(index, 1);
			}
		}
	}

	/**
	 * Check existence of the filter
	 * @param key Key of the filter to be checked for existence.
	 */
	@action hasFilter = (key: string) => {
		return this.documentFilters.some(filter => filter.name == key);
	}

	/**
	 * Find filter by key
	 * @param key Key of the filter to be found.
	 */
	@action findFilter = (key: string) => {
		return this.documentFilters.find(filter => filter.name == key);
	}

	/**
	 * Clear filters.
	 */
	@action clearFilter = () => {
		return this.documentFilters.clear();
	}

	/**
	 * Create file variant
	 * @param documentId
	 */
	@action public createFileVariant(documentId: string, language: string): string {
		let result = documentId + ".";
		if (language) {
			result += language;
		}
		return result;
	}

}

export var DocumentFilter = new DocumentFilterPersistentImpl();